import { UPDATE_CORRELATION_ID } from '../actions';

export const correlationId = (state = '', action) => {
  switch (action.type) {
    case UPDATE_CORRELATION_ID: {
      return action.correlationId;
    }
    default:
      return state;
  }
};
